<template>
  <div class="custom-dropdown" ref="dropdownContainer">
    <div
      class="custom-dropdown-title flex-rowc"
      @click="toggleDropdown"
    >
      <i class="region-icon"></i>
      <div class="filter-item-title flex flex-align-center">
        <slot>所有地區</slot>
      </div>
      <i class="dropdown-down-icon" :class="{ 'active': isActive }"></i>
    </div>
    <div
      class="custom-dropdown-menu"
      :class="{ active: isActive }"
    >
      <div 
        class="custom-dropdown-item"
        v-for="(item, index) in options"
        :key="index"
        @click="selectItem(item, index)"
      >
        {{ item.text }}
      </div>
      <slot name="menuContent"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CustomDropdown',
  props: {
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isActive: false
    };
  },
  mounted() {
    // 添加点击外部关闭下拉框的事件监听
    document.addEventListener('click', this.handleDocumentClick);
  },
  beforeUnmount() {
    // 移除事件监听，避免内存泄漏
    document.removeEventListener('click', this.handleDocumentClick);
  },
  methods: {
    toggleDropdown() {
      // 检查options是否为空
      if (this.options.length === 0) {
        // 如果options为空，触发emptyClick事件
        this.$emit('emptyClick');
        return;
      }
      
      // 如果options不为空，正常切换下拉框显示状态
      this.isActive = !this.isActive;
    },
    selectItem(item, index) {
      // 触发选择事件，传递选中的项和索引
      this.$emit('select', item, index);
      // 选择后关闭下拉框
      this.isActive = false;
    },
    handleDocumentClick(event) {
      // 检查点击是否发生在下拉框外部
      if (this.$refs.dropdownContainer && !this.$refs.dropdownContainer.contains(event.target)) {
        this.isActive = false;
      }
    }
  }
};
</script>

<style scoped>
.custom-dropdown {
  position: relative;
  cursor: pointer;
}

.custom-dropdown-title {
  cursor: pointer;
}

.custom-dropdown .custom-dropdown-title .filter-item-title {
  margin: 0 4px;
  min-width: 72px;
  max-width: 130px;
  /* // 单行隐藏 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  color: #333333;
}
/* .custom-dropdown .custom-dropdown-title .filter-item-title:hover {
  color: #497bcf;
} */

.dropdown-down-icon {
  transition: transform 0.3s ease;
}

.dropdown-down-icon.active {
  transform: rotate(180deg);
}

.custom-dropdown-menu {
  position: absolute;
  top: 40px;
  left: 50%;
  transform: translateX(-50%);
  width: 150px;
  height: auto;
  max-height: 280px;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  padding: 10px 0;
  opacity: 0;
  /* visibility: hidden; */
  transition: all 0.3s ease;
  z-index: 1000;
  box-sizing: border-box;
}

.custom-dropdown-menu.active {
  opacity: 1;
  visibility: visible;
}

.custom-dropdown-item {
  padding: 12px 20px;
  font-size: 16px;
  color: #333333;
  transition: background-color 0.3s ease;
  box-sizing: border-box;
}

.custom-dropdown-item:hover {
  background-color: #f5f5f5;
}

/* 滚动条样式 */
.custom-dropdown-menu::-webkit-scrollbar {
  width: 4px;
}

.custom-dropdown-menu::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.custom-dropdown-menu::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.custom-dropdown-menu::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>